const numberFormat = new Intl.NumberFormat("hu-HU", {
    maximumFractionDigits: 2
})
export const formatCurrency = (value, currency) => {
    return `${numberFormat.format(value)} ${currency}`
}